/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpsertTimeOffRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {UpsertTimeOffResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const upsertTimeOff = (request: UpsertTimeOffRequest, options?: CashRequestOptions) => post<UpsertTimeOffRequest, UpsertTimeOffResponse>("/2.0/cash/upsert-time-off", request, {...options, rejectOnError: true })